// frontend/optica-frontend/src/utils/demoMode.js

export const EMAIL_DEMO = 'usuarioprueba@optica.com';

/**
 * Verifica si el usuario actual corresponde a la cuenta oficial de demostración.
 * @param {Object} usuario 
 * @returns {boolean}
 */
export const isDemoUser = (usuario) => {
  if (!usuario || !usuario.email) return false;
  return String(usuario.email).trim().toLowerCase() === EMAIL_DEMO;
};

/**
 * Dispara el evento global para abrir el modal de bienvenida y tour de módulos.
 */
export const abrirTourDemo = () => {
  window.dispatchEvent(new CustomEvent('demo:abrir-tour'));
};

/**
 * Dispara el evento global para solicitar el registro de una nueva óptica
 * cuando el usuario demo intenta crear/cargar información.
 * @param {string} motivo Texto opcional indicando qué intentó cargar (ej: 'cargar pacientes', 'crear ventas', etc.)
 */
export const solicitarRegistroDemo = (motivo = 'cargar tu propia información') => {
  window.dispatchEvent(new CustomEvent('demo:solicitar-registro', {
    detail: { motivo }
  }));
};
